import { IELT_WRITE, IELT_READ } from 'app/constants/categories';
import { setCurrentPage } from 'app/actions/tests';
import { scrollToQuestion } from 'app/utils/test';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import { Group, Passage } from 'types/test';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import React, { useMemo } from 'react';
import uniq from 'lodash/uniq';

const TaskButtons: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { currentPage, test, groupQuestions } = useSelector((state: AppStoreState) => state.test);

  const pages = useMemo(() => {
    if (test?.passages && test?.passages?.length > 0) {
      return test.passages.map((passage: Passage) => {
        return passage.passage_number;
      })
    }

    const partIds = groupQuestions
      .map((group: Group) => group.part_id)
      .filter((taskId: number) => taskId != null);

    return uniq(partIds);
  }, []);

  const onChangePage = (id: number) => {
    dispatch(setCurrentPage(id));

    scrollToQuestion();
  };

  return (
    <div className="text-center mt-5 mb-2">
      {pages?.length > 1 && pages.map((pageNumber: number) => (
        <div key={pageNumber} className="btn-group">
          <button
            type="button"
            className={`m-1 mt-3 btn btn-sm ${currentPage === pageNumber ? 'btn-secondary' : 'btn-outline-secondary'}`}
            onClick={() => onChangePage(pageNumber)}
          >
            {[IELT_WRITE, IELT_READ].includes(test.category_id) ? t('tests.task_prefix') : 'Part'}
            <span className='pl-1'>{pageNumber}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default TaskButtons;
